import React, {useMemo} from "react";
import {PolarGrid, Radar, RadarChart, ResponsiveContainer} from "recharts";

export default function SkeletonRadarChart() {
    const data = useMemo(() => {
        const result = [];
        for (let i = 0; i < 5; i++) {
            result.push({
                name: `Label ${i + 1}`,
                value: Math.floor(Math.random() * 1000),
            });
        }
        return result;
    }, []);

    return (
        <ResponsiveContainer height="100%">
            <RadarChart data={data}>
                <PolarGrid />
                <Radar
                    dataKey={"value"}
                    isAnimationActive={false}
                    className="skeleton-svg"
                />
            </RadarChart>
        </ResponsiveContainer>
    );
}
